<template lang="pug">
  .address-box.address-box--company(v-if="address" v-bind:class="{'address-box--selectable': selectable}")
    .address-box__actions
      a.address-box__action(href='#', :title="trans('labels.general.buttons.edit')" @click.prevent="onEdit")
        i.far.fa-edit
        |  {{ trans('labels.general.buttons.edit') }}
      a.address-box__action(href='#', :title="trans('labels.general.buttons.delete')" @click.prevent="onDelete")
        i.far.fa-trash
        |  {{ trans('labels.general.buttons.delete') }}
    div(v-if="selectable")
      .custom-radio.custom-radio--shipping-address(@click="onClick")
        input#custom-radio(type='radio', :name='"custom-radio-" + address.id', :value='true' v-model='selected')
        .custom-radio__content
          label.custom-radio__label
            span.address-box__name {{ address.company_name }}
            span.address-box__tax-no {{ trans('labels.frontend.user.profile.tax-number') }} {{ address.tax_number }}
            span.address-box__brand {{ trans('labels.frontend.user.profile.branch-number') }} {{ address.branch_number === '' ? trans('labels.frontend.user.profile.headquarter') : address.branch_number }}
            span.address-box__address
            | {{ address.address }}
            | {{ address.district_txt ? address.district_txt : address.district ? address.district.name_th : '' }} {{ address.amphure ? address.amphure.name_th : '' }}
            | {{ address.province.name_th }}
            | {{ address.postal_code }}
    div.d-flex.flex-column.w-100(v-if="!selectable")
      span.address-box__name {{ address.company_name }}
      span.address-box__tax-no {{ trans('labels.frontend.user.profile.tax-number') }} {{ address.tax_number }}
      span.address-box__brand {{ trans('labels.frontend.user.profile.branch-number') }} {{ address.branch_number === '' ? trans('labels.frontend.user.profile.headquarter') : address.branch_number }}
      span.address-box__address
      | {{ address.address }}
      | {{ address.district_txt ? address.district_txt : address.district ? address.district.name_th : '' }} {{ address.amphure ? address.amphure.name_th : '' }}
      | {{ address.province.name_th }}
      | {{ address.postal_code }}
    delete-address-modal(:address="address" :name="'delete-billing-modal-' + address.id" type="billing" @deleted="onDeleted")
    billing-address-modal(mode="edit" :addressId="address.id" :name="'edit-billing-modal-' + address.id" @updated="onUpdated")
</template>

<script>
import BillingAddressModal from '../modals/BillingAddressModal.vue';
import DeleteAddressModal from '../modals/DeleteAddressModal.vue';

export default {
  components: {
    BillingAddressModal,
    DeleteAddressModal,
  },
  props: {
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    address: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked', this.address);
    },
    onEdit() {
      this.$bvModal.show(`edit-billing-modal-${this.address.id}`);
    },
    onUpdated(address) {
      this.$emit('updated', address);
    },
    onDelete() {
      this.$bvModal.show(`delete-billing-modal-${this.address.id}`);
    },
    onDeleted(address) {
      this.$bvModal.hide(`delete-billing-modal-${this.address.id}`);
      this.$emit('deleted', address);
    },
  },
};
</script>
